<template>
  <div class="email-login-form">
    <div class="">
      <div class="left-login">
        <div class="rep-icon-login">
          <img src="../../assets/images/dashboard-rep.svg" alt="image-fluid" />
        </div>
        <div class="">
          <router-link to="/smart-login">
            <button class="qr-login-btn">
              <img src="../../assets/images/qr-icon.svg" alt="qr icon" class="me-2" />Login with QR
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <h4 class="login-title mb-0">Login to Continue</h4>

    <div class="auth-form pt-1 pb-3">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form @submit.stop.prevent="handleSubmit(checkEmailLogin)">
          <custom-input-text :rules="{ required: true, email: true }"
            :customMessages="`Please enter your email address.`"
            :customEmailMessage="`Please enter a valid email address`" labelFor="Email" labelName="Email"
            inputName="Email" formGroupClass="form-group mb-1" placeholder="Please enter your email"
            @emitChanges="resetErrorMsg" :isErrorFlagSet="emailErrorFlag" :vmodel.sync="form.username" />
          <div class="valid-error" v-if="emailErrorFlag && lockoutTime === 0">
            {{ errorMsg }}
          </div>
            <router-link :to="{ name: 'ForgotEmail' }" class="text-end login-highlight">
              <p class="float-right">Forgot Email?</p>
            </router-link>
          <button class="submit-btn  next-btn" :disabled="loginLoader || lockoutTime > 0" type="submit">
            <b-spinner v-if="loginLoader" small></b-spinner>
            Next
          </button>
        </form>
      </ValidationObserver>
      <lockout-timer
        v-if="lockoutTime > 0"
        :lockout-seconds="lockoutTime"
        @lockout-expired="handleLockoutExpired"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CustomInputText from "../../components/form/CustomInputText.vue";
import LockoutTimer from "../../components/ui/LockoutTimer";

export default {
  name: 'EmailLoginForm',
  components: {
    CustomInputText,
    'lockout-timer': LockoutTimer
  },
  data() {
    return {
      form: { username: "", deviceID: "" },
      loginLoader: false,
      emailErrorFlag: false,
      errorMsg: '',
      lockoutTime: 0 
    };
  },
  mounted() {
    let uniqueDeviceId = this.$store.getters.deviceId || this.$uuid.v1();
    this.form.deviceID = uniqueDeviceId;
    this.$store.commit("setDeviceId", uniqueDeviceId);
    this.form.username = this.$store.getters.repEmail;
    this.emailErrorFlag = false;
  },
  methods: {
    checkEmailLogin() {
      let app = this;
      this.$store.commit("setAuthentication", false);
      app.loginLoader = true;
      app.$store.commit("setRepEmail", this.form.username);
      this.$store.commit("setLoginOtpSource", 'login'); // Set the source for login OTP
      axios
        .post(app.$endpoint.API_EMAIL_VALIDATE_v4_URL, {
          email: app.form.username,
          device_id: app.form.deviceID,
        })
        .then(function (response) {
          if (response.data.status == "success") {
            app.$router.push('/password-login')
            app.loginLoader = false;
          }
        })
        .catch(function (error) {
          app.loginLoader = false;
          if (error.response?.status === 429 || error.response?.remaining_attempts === 0) {
            const lockoutMatch = error.response.data.message?.match(/Try again after (\d+) seconds/);
            if (lockoutMatch && lockoutMatch[1]) {
              app.lockoutTime = parseInt(lockoutMatch[1], 10);
              app.resetErrorMsg();
            }
          } else if (error.response?.data?.status == "error") {
            app.emailErrorFlag = true;
            app.errorMsg = error.response.data.message || "An error occurred. Please try again.";
          }
        });
    },
    resetErrorMsg() {
      this.emailErrorFlag = false;
      this.errorMsg = '';
    },
    handleLockoutExpired() {
      this.lockoutTime = 0;
      this.emailErrorFlag = false; 
      this.errorMsg = ''; 
    }
  }
};
</script>

<style>
.multi-step-form {
  margin: auto;
}

.email-login-form .invalid-feedback {
  color: #E73737;
  background-color: #FFE9E9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}

.multi-step-form .step-indicator {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.multi-step-form .step-indicator span {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.multi-step-form .step-indicator span.active {
  background-color: #007bff;
  color: white;
}

.multi-step-form form {
  display: flex;
  flex-direction: column;
}

.multi-step-form label {
  margin-top: 10px;
}

.login-password-container {
  position: relative !important;
}

.login-toggle-eye-icon {
  position: absolute;
  top: 10px;
  right: 8px;
  cursor: pointer;
}

.login-password-container .is-valid {
  background-image: none !important;
}

.login-password-container .is-invalid {
  background-image: none !important;
}

.attempts-warning {
  color: #ff9800;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  font-weight: 500;
  padding: 4px 8px;
  background: #fff3e0;
  border-radius: 4px;
  display: inline-block;
}

.valid-error {
  color: #e73737;
  background-color: #ffe9e9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.5rem;
  font-size: 0.9rem;
}

.email-login-form .invalid-feedback {
  color: #E73737;
  background-color: #FFE9E9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}
</style>